export default function authHeader() {


    //let user = JSON.parse(localStorage.getItem(window.location.href.split('/')[3]+'User'));
    let userType = (window.location.pathname.startsWith('/doctor/') || window.location.pathname.startsWith('/admin/')) ? (window.location.pathname.split('/')[1] + 'User') : ('user');
    console.log(userType);
    let user = JSON.parse(localStorage.getItem(userType));

    if (user && user.token) {
        return {Authorization: 'Bearer ' + user.token}; // for Spring Boot back-end
        // return { 'x-access-token': user.accessToken };       // for Node.js Express back-end
    } else {
        return {};
    }
}
